import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import brands from "../../assets/db/BrandLogo";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

const BrandWiseStock = () => {
  const [inventory, setInventory] = useState([]);
  const [distinctBrands, setDistinctBrands] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showInStockOnly, setShowInStockOnly] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInventory = async () => {
      setLoading(true);
      try {
        const inventoryCollection = collection(db, "all-products");
        const inventorySnapshot = await getDocs(inventoryCollection);
        const inventoryList = inventorySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Apply the same filtering logic
        const filtered = inventoryList.filter((item) => {
          const history = item.history || [];
          const firstStatus = history[0]?.status;
          return (
            (history.length === 1 && firstStatus === "inventory") ||
            (history.length === 2 && history[1]?.status === "transferred")
          );
        });

        // Calculate brand-wise stock
        const brandwiseStock = filtered.reduce((acc, item) => {
          const { brand } = item;
          acc[brand] = (acc[brand] || 0) + 1;
          return acc;
        }, {});

        setInventory(filtered);
        setDistinctBrands(
          Object.entries(brandwiseStock).map(([brand, quantity]) => ({
            brand,
            quantity,
          }))
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInventory();
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleBrandClick = (brandName) => {
    const filteredModels = inventory.filter((item) => item.brand === brandName);
    navigate("/all-models", { state: { filteredModels, brandName } });
  };

  const filteredBrands = showInStockOnly
    ? brands.filter((brand) =>
        distinctBrands.some((b) => b.brand === brand.name && b.quantity > 0)
      )
    : brands;

  return (
    <div className="p-6 bg-white h-screen">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">All Brands</h1>
        <button
          onClick={() => setShowInStockOnly(!showInStockOnly)}
          className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 transition w-1/6"
        >
          {showInStockOnly ? "Show All Brands" : "Show Brands in Stock"}
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {filteredBrands.map((brand, index) => {
          const brandData = distinctBrands.find((b) => b.brand === brand.name);
          const quantity = brandData ? brandData.quantity : 0;

          return (
            <div
              key={index}
              onClick={() => handleBrandClick(brand.name)}
              className="border rounded-lg p-4 flex flex-col items-center shadow hover:shadow-lg transition bg-gray-50 cursor-pointer"
            >
              <img
                src={brand.logoUrl}
                alt={brand.name}
                className="w-16 h-16 object-contain mb-2 mix-blend-multiply"
              />
              <p className="text-sm font-normal text-gray-800">{brand.name}</p>
              <div className="mt-2 w-full text-center bg-gray-200 rounded-lg py-1">
                <p
                  className={`text-sm font-medium ${
                    quantity === 0 ? "text-red-500" : "text-green-500"
                  }`}
                >
                  Stock: {quantity}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BrandWiseStock;
